module.exports = __webpack_public_path__ + "img/overview-address-icon.svg";